import { render, staticRenderFns } from "./migrated-alert.component.vue?vue&type=template&id=a0108a78&"
import script from "./migrated-alert.component.vue?vue&type=script&lang=ts&"
export * from "./migrated-alert.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports